// import Routes from './Routes.js';
import './App.css';
import LogUp from "./containers/LogUp.js";

function App() {
  return ( 
    <div className="App">
   <LogUp/>
    </div>
   
  );
}

export default App;